module.exports = __webpack_public_path__ + "static/media/diktat-39.3bed696b.mp3";